module.exports = __webpack_public_path__ + "b08fd397a5a4be486b3665e4f7647114.png";